import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  ArrowDownOutlined,
  ArrowUpOutlined,
  CloseOutlined,
  CommentOutlined,
  CopyOutlined,
  DeleteOutlined,
  EditOutlined,
  EnterOutlined,
  PlayCircleOutlined,
  PlusOutlined,
  SaveOutlined,
  UserOutlined,
} from "@ant-design/icons";
import {
  App,
  Avatar,
  Button,
  Dropdown,
  Flex,
  Input,
  InputNumber,
  Popover,
  Space,
  Tooltip,
  Typography,
} from "antd";
import { refineSpecificTimer } from "util/refine_timer.function";
import { AiOutlineRollback } from "react-icons/ai";
import { useSelector } from "react-redux";
import {
  draftDialogCommentsSelector,
  draftDialogSecondSelector,
  draftDialogSpeakersSelector,
} from "store/bailiff/draft/dialog/draft_dialog.selector";
import moment from "moment";
import { useDispatch } from "react-redux";
import { IoIosArrowDown } from "react-icons/io";
import { setDraftDialogKick } from "store/bailiff/draft/dialog/draft_dialog.action";
import { useActionDraftMerge } from "hook/draft/dialog/useActionDraftMerge";
import { useActionDraftComment } from "hook/draft/dialog/useActionDraftComment";
import { floor, round } from "lodash";
//
//component
//redux
//selector
//actions
//utils
//hook
//str

const CardDraftMerge = ({ data, index, highlight }) => {
  // -------------------------- VAR -----------------------------
  const {
    handleChangeSpeaker,
    handleAddAboveSpeaker,
    handleResetContentMerge,
    handleUpdateInfoMerge,
    handleDeleteMerge,
  } = useActionDraftMerge();
  const { handleAddFeedback } = useActionDraftComment();

  const { message } = App?.useApp();
  const ref = useRef(null);
  const isSpeaker1 = index % 2 === 0;
  const speakerColor = isSpeaker1 ? "bg-blue-600" : "bg-red-500";
  const speakerName =
    data?.fixSpeaker || data?.speaker || `Speaker ${isSpeaker1 ? "1" : "2"}`;
  const start = data?.fixFrom || data?.from;
  const end = data?.fixTo || data?.to;
  const id = data?.segId;

  const labelStart = refineSpecificTimer({ timer: start });
  const labelEnd = refineSpecificTimer({ timer: end });
  const raw = data?.text || null;
  const fix = data?.fix || null;
  const content = fix || raw || "";
  const adjusted = raw && fix;
  const classAdjusted = adjusted ? "text-green-700" : "text-gray-700";
  const inputNumberStyle = {
    controls: false,
    min: 0,
    keyboard: true,
    changeOnWheel: true,
  };
  // -------------------------- STATE ---------------------------
  const [hover, setHover] = useState(false);
  const [edit, setEdit] = useState(false);
  const [hideCom, setHideCom] = useState(false);
  const [from, setFrom] = useState({ hr: 0, min: 0, sec: 0 });
  const [to, setTo] = useState({ hr: 0, min: 0, sec: 0 });
  const [text, setText] = useState("");
  const [feedback, setFeedback] = useState("");
  // -------------------------- REDUX ---------------------------
  const dispatch = useDispatch();
  const second = useSelector(draftDialogSecondSelector);
  const speakers = useSelector(draftDialogSpeakersSelector);
  const comments = useSelector(draftDialogCommentsSelector);
  const fComments = comments?.filter((c) => c?.id === id) || [];
  const validHL = second >= start && second <= end && highlight;
  const classHighlight = validHL ? "bg-yellow-200" : classAdjusted;
  const existSpeaker = speakers?.find((item) => item?.label === speakerName);
  const speakerColorChosen = existSpeaker?.color || speakerColor;
  const labelSpeaker = existSpeaker?.label || speakerName || "Speaker";

  // -------------------------- FUNCTION ------------------------
  const handleSelect = () => {
    const id = `change-${moment()?.valueOf()}-${start}`;
    dispatch(setDraftDialogKick(id));
  };

  const scrollToSection = useCallback(() => {
    if (!ref?.current) return;
    ref.current?.scrollIntoView({
      behavior: "smooth",
      block: "center", // Hoặc 'center' nếu muốn căn giữa màn hình
    });
  }, [ref]);

  const handleSpeaker = (key) => {
    if (!key || !id) return;
    console.log({ key, id });
    return handleChangeSpeaker(id, key);
  };

  const handleReset = () => {
    if (!id) return;
    return handleResetContentMerge(id);
  };

  const handleAddBelow = () => {
    if (!id) return;
    return handleAddAboveSpeaker(id);
  };

  const copyToClipboard = () => {
    if (!content) return;
    navigator.clipboard.writeText(content);
    message.info("Copy thành công!");
  };

  const handleSave = () => {
    if (!id || !text || from < 0 || to < 0) return;
    const validFrom = convertClockToDuration(from);
    const validTo = convertClockToDuration(to);
    const info = { text, from: validFrom, to: validTo };
    return handleUpdateInfoMerge(id, info);
  };

  const handleDelete = () => {
    if (!id) return;
    return handleDeleteMerge(id);
  };

  const handleSendFeedback = () => {
    if (!id || !feedback) return;
    return handleAddFeedback({ id, feedback, setHideCom });
  };

  // -------------------------- EFFECT --------------------------
  useEffect(() => {
    if (validHL) {
      scrollToSection();
    }
  }, [validHL, scrollToSection]);

  useEffect(() => {
    if (!data) return;
    const fromClock = convertDurationToClock(data?.fixFrom || data?.from);
    const toClock = convertDurationToClock(data?.fixTo || data?.to);
    setFrom(fromClock);
    setTo(toClock);
    setText(data?.fix || data?.text);
  }, [data]);

  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const renderAdjust = () => {
    if (fix && raw) {
      return (
        <Typography.Paragraph
          delete={true}
          type="danger"
          ellipsis={{
            rows: 3,
            expandable: true,
            symbol: "Xem thêm",
          }}
          className="min-h-[30px] rounded-sm p-0 p-2"
        >
          {raw}
        </Typography.Paragraph>
      );
    }
  };

  const renderPlay = () => {
    if (!hover) return null;
    return (
      <div className="flex flex-row items-center gap-1">
        <Button
          onClick={handleSelect}
          size="small"
          type="text"
          className="rounded-sm p-2 text-blue-600"
          icon={<PlayCircleOutlined />}
        >
          Nghe
        </Button>
        {fComments?.length > 0 && (
          <Popover
            title="Góp ý đoạn văn"
            trigger={"click"}
            content={renderContentFeedbacks()}
            placement="right"
          >
            <Button size="small" icon={<CommentOutlined />} type="text">
              {fComments?.length || 0} Góp ý
            </Button>
          </Popover>
        )}
      </div>
    );
  };

  const renderContentFeedbacks = () => {
    if (fComments?.length > 0) {
      return (
        <div className="flex flex-col gap-2">
          {fComments?.map((f, index) => {
            const feedback = f?.feedback || "";
            const feedbackName = f?.feedbackName || "";
            return (
              <div className="flex flex-col gap-1" key={index}>
                <Typography.Text className="!text-[12px]" type="secondary">
                  + {feedback}
                </Typography.Text>
                <Typography.Text italic className="!text-[10px]">
                  ({feedbackName})
                </Typography.Text>
              </div>
            );
          })}
        </div>
      );
    }
  };

  const renderEdit = () => {
    if (!edit) {
      return (
        <Tooltip title="Chỉnh sửa">
          <Button
            onClick={() => setEdit(true)}
            type="text"
            icon={<EditOutlined className="text-[16px]" />}
          />
        </Tooltip>
      );
    }

    return (
      <div className="flex flex-row gap-1">
        <Tooltip title="Thoát">
          <Button
            onClick={() => setEdit(false)}
            type="text"
            icon={<CloseOutlined className="text-[16px]" />}
          />
        </Tooltip>
        <Tooltip title="Lưu chỉnh sửa">
          <Button
            onClick={() => {
              setEdit(false);
              handleSave();
            }}
            type="text"
            icon={<SaveOutlined className="text-[16px]" />}
          />
        </Tooltip>
      </div>
    );
  };

  const renderActions = () => {
    if (!hover) return null;
    return (
      <div className="absolute right-0 top-[-10px] flex h-[40px] min-w-[100px] flex-row items-center justify-end gap-1 rounded-md border-[1px] border-gray-100 bg-white p-2 shadow-md">
        <Tooltip title="Hoàn trả nội dung cũ">
          <Button
            onClick={handleReset}
            type="text"
            icon={<AiOutlineRollback className="text-[16px]" />}
          />
        </Tooltip>
        <Tooltip title="Copy nội dung">
          <Button
            onClick={copyToClipboard}
            type="text"
            icon={<CopyOutlined className="text-[16px]" />}
          />
        </Tooltip>
        <Tooltip title="Góp ý">
          <Button
            onClick={() => setHideCom(true)}
            type="text"
            icon={<CommentOutlined className="text-[16px]" />}
          />
        </Tooltip>
        {renderEdit()}
        <Tooltip title="Thêm hội thoại bên dưới">
          <Button
            onClick={handleAddBelow}
            type="text"
            icon={<PlusOutlined className="text-[16px]" />}
          />
        </Tooltip>
        <Tooltip title="Xoá hội thoại">
          <Button
            onClick={handleDelete}
            type="text"
            danger
            icon={<DeleteOutlined className="text-[16px]" />}
          />
        </Tooltip>
      </div>
    );
  };

  const renderSpeaker = () => {
    if (!speakers) return null;
    if (!hover)
      return (
        <span className="text-sm font-semibold text-gray-900">
          {labelSpeaker}
        </span>
      );

    const items = speakers?.map((s, i) => {
      return {
        key: s?.key,
        label: (
          <div className="flex flex-row gap-1">
            <UserOutlined
              className="rounded-full p-1 text-white"
              style={{ background: s?.color }}
            />{" "}
            {s?.label}
          </div>
        ),
        onClick: () => handleSpeaker(s?.label),
      };
    });
    return (
      <Dropdown menu={{ items }} trigger={["click"]}>
        <div className="flex cursor-pointer flex-row items-center gap-1 text-sm font-semibold text-gray-900 hover:bg-gray-200">
          {labelSpeaker} <IoIosArrowDown />{" "}
        </div>
      </Dropdown>
    );
  };

  const renderStartEnd = () => {
    if (!edit) {
      return (
        <>
          {labelStart} - {labelEnd}
        </>
      );
    }

    return (
      <div className="flex flex-col gap-1">
        <span>From</span>
        <Space.Compact>
          <InputNumber
            {...inputNumberStyle}
            step={1}
            value={from?.hr}
            suffix="h"
            style={{ width: 75 }}
            onChange={(value) => setFrom({ ...from, hr: value })}
          />
          <InputNumber
            {...inputNumberStyle}
            max={59}
            step={1}
            value={from?.min}
            suffix="m"
            style={{ width: 75 }}
            onChange={(value) => setFrom({ ...from, min: value })}
          />
          <InputNumber
            {...inputNumberStyle}
            value={from?.sec}
            max={60}
            suffix="s"
            formatter={(value) => `${round(value, 1)}`}
            onChange={(value) => setFrom({ ...from, sec: value })}
          />
        </Space.Compact>
        <span>To</span>
        <Space.Compact>
          <InputNumber
            {...inputNumberStyle}
            value={to?.hr}
            step={1}
            suffix="h"
            style={{ width: 75 }}
            onChange={(value) => setTo({ ...to, hr: value })}
          />
          <InputNumber
            {...inputNumberStyle}
            value={to?.min}
            max={59}
            step={1}
            suffix="m"
            style={{ width: 75 }}
            onChange={(value) => setTo({ ...to, min: value })}
          />
          <InputNumber
            {...inputNumberStyle}
            value={to?.sec}
            max={60}
            step={0.1}
            suffix="s"
            formatter={(value) => `${round(value, 1)}`}
            onChange={(value) => setTo({ ...to, sec: value })}
          />
        </Space.Compact>
      </div>
    );
  };

  const renderContent = () => {
    if (!edit) {
      return <> {fix || raw}</>;
    }

    return (
      <Input.TextArea
        value={text}
        rows={5}
        onChange={(e) => setText(e.target.value)}
      />
    );
  };

  const renderComment = () => {
    if (!hideCom) {
      return null;
    }

    return (
      <div className="absolute bottom-[-20px] left-[50px] flex h-[40px] min-w-[100px] flex-row items-center justify-end gap-1 rounded-md border-[1px] border-gray-100 bg-white p-2 shadow-md">
        <Input
          value={feedback}
          onChange={(e) => setFeedback(e.target.value)}
          placeholder="Nhập feedback"
          variant="borderless"
        />
        <Button
          onClick={handleSendFeedback}
          type="link"
          icon={<EnterOutlined />}
        >
          Gửi
        </Button>
        <Button
          onClick={() => setHideCom(false)}
          type="link"
          danger
          icon={<CloseOutlined />}
        >
          Đóng
        </Button>
      </div>
    );
  };

  // -------------------------- MAIN ----------------------------
  return (
    <div
      ref={ref}
      className="group relative -mx-2 my-4 flex gap-6 rounded-lg p-2 transition-colors hover:bg-slate-50"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      {renderActions()}

      <div className="w-[150px] shrink-0 pt-1.5 text-right font-mono text-[10px] font-medium text-gray-400">
        {renderStartEnd()}
      </div>
      <div className="flex-1">
        <div className="mb-1.5 flex items-center gap-2">
          <Avatar
            size={24}
            style={{ background: speakerColorChosen }}
            className={`bg-[${speakerColorChosen}] flex items-center justify-center shadow-sm`}
            icon={<UserOutlined />}
          />
          {renderSpeaker()}
          <span>{renderPlay()}</span>
        </div>
        {renderAdjust()}
        <p className={`relative text-base leading-relaxed ${classHighlight}`}>
          {renderContent()}
          {renderComment()}
        </p>
      </div>
    </div>
  );
};
export default CardDraftMerge;

const convertDurationToClock = (num) => {
  const hr = floor(num / 3600);
  const hrRemain = num % 3600;
  const min = floor(hrRemain / 60);
  const sec = hrRemain % 60;
  return { hr, min, sec };
};

const convertClockToDuration = ({ hr, min, sec }) => {
  return hr * 3600 + min * 60 + sec;
};
